import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IPaginatedResponse } from '../../interfaces/api/responses.interface';

@Injectable({
  providedIn: 'root',
})
export class EmployeeLocalService {
  private apiUrl = `${environment.apiUrl}/auth`;
  private apiUrlEmployee = `${environment.apiUrl}/employees`;
  private apiUrlContract = `${environment.apiUrl}/contracts`;

  constructor(private http: HttpClient) {}

  // Employees
  createEmployee(data: FormData): Observable<any> {
    return this.http.post<any>(this.apiUrl + '/registerEmployee', data);
  }

  postEmployeeByCompany(filter: Record<string, unknown>): Observable<IPaginatedResponse<any>> {
    return this.http.post<IPaginatedResponse<any>>(
      this.apiUrlEmployee + '/listEmployeeByCompanyV2',
      filter
    );
  }

  postEmployeeBulkProcess(data: FormData): Observable<IPaginatedResponse<any>> {
    return this.http.post<IPaginatedResponse<any>>(
      this.apiUrlEmployee + '/bulk/process',
      data
    );
  }

  postEmployeeBulkProcessPage(filter: Record<string, unknown>): Observable<IPaginatedResponse<any>> {
    return this.http.post<IPaginatedResponse<any>>(
      this.apiUrlEmployee + '/bulk/process/page',
      filter
    );
  }

  postEmployeeBulkRemoveRow(filter: Record<string, unknown>): Observable<IPaginatedResponse<any>> {
    return this.http.post<IPaginatedResponse<any>>(
      this.apiUrlEmployee + '/bulk/remove-row',
      filter
    );
  }

  postEmployeeBulkRegister(filter: Record<string, unknown>): Observable<any> {
    return this.http.post<any>(
      this.apiUrlEmployee + '/bulk/register',
      filter
    );
  }

  updateEmployee(id: number, data: FormData): Observable<any> {
    return this.http.put<any>(`${this.apiUrlEmployee}/${id}`, data);
  }

  createEmployeeAndContract(data: FormData): Observable<any> {
    return this.http.post<any>(
      this.apiUrlEmployee + '/registerEmployeeContract',
      data
    );
  }

  // Contracts
  createContract(data: FormData): Observable<any> {
    return this.http.post<any>(this.apiUrlContract + '/registerContract', data);
  }

  getContractByContractId(idContract: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrlContract}/${idContract}`);
  }

  postContractByCompany(filter: Record<string, unknown>): Observable<IPaginatedResponse<any>> {
    return this.http.post<IPaginatedResponse<any>>(
      this.apiUrlContract + '/ListContractByCompany',
      filter
    );
  }

  updateChangeStateContract(idContract: number, data: FormData): Observable<any> {
    return this.http.put<any>(`${this.apiUrlContract}/changeStateContract/${idContract}`, data);
  }

  updateContract(id: number, data: FormData): Observable<any> {
    return this.http.put<any>(`${this.apiUrlContract}/${id}`, data);
  }

  getContractDetailByEmployeeId(employeeId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrlContract}/detail/${employeeId}`);
  }

  postContractHistoryByEmployeeId(
    employeeId: number,
    filters: Record<string, unknown>
  ): Observable<IPaginatedResponse<any>> {
    return this.http.post<IPaginatedResponse<any>>(
      `${this.apiUrlContract}/history/${employeeId}`, 
      filters
    );
  }
}
